import { ShopperBuyProductPayScanConfirmPage } from './shopper-buy-product-pay-scan_confirm';
import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    ShopperBuyProductPayScanConfirmPage,
  ],
  imports: [
    IonicPageModule.forChild(ShopperBuyProductPayScanConfirmPage),
    TranslateModule.forChild()
  ],
})
export class ShopperBuyProductPayScanConfirmPageModule {}



// WEBPACK FOOTER //
// ./src/pages/shopper-buy-product-pay-scan_confirm/shopper-buy-product-pay-scan_confirm.module.ts